import React, { FC, useEffect } from "react";
import { Box } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import { TaxierenPrintData } from "../types/interface";
import A4PrintComponent from "../../Edit/components/helper-components/A4PrintComponent";
import A5PrintComponent from "../../Edit/components/helper-components/A5PrintComponent";

interface GkvEditPrintOverlayProps {
  printData: TaxierenPrintData | null;
  printRef: React.RefObject<HTMLDivElement>;
  onAfterPrint: () => Promise<void>;
}

/**
 * Hidden overlay that renders A4/A5 print components for taxieren.
 *
 * When `printData` is set, the useEffect triggers react-to-print
 * which opens the browser's print dialog.
 * After printing, `onAfterPrint` is called to update taxieren status.
 */
const GkvEditPrintOverlay: FC<GkvEditPrintOverlayProps> = ({
  printData,
  printRef,
  onAfterPrint,
}) => {
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint,
  });

  // Trigger print when printData is set
  useEffect(() => {
    if (printData) {
      handlePrint();
    }
  }, [printData, handlePrint]);

  if (!printData) return null;

  return (
    <Box sx={{ position: "absolute", left: "-9999px", top: 0 }}>
      <div ref={printRef}>
        {printData.isZahnarzt ? (
          <A4PrintComponent
            billNumber={printData.billNumber}
            rxNumber={printData.rxNumber}
            careProviderIk={printData.careProviderIk}
          />
        ) : (
          <A5PrintComponent
            billNumber={printData.billNumber}
            rxNumber={printData.rxNumber}
            careProviderIk={printData.careProviderIk}
          />
        )}
      </div>
    </Box>
  );
};

export default React.memo(GkvEditPrintOverlay);
